import { supabase } from './supabase';

/**
 * Consulta CNPJ via /api/cnpj (proxy server-side que tenta Receita primeiro
 * e cai pra BrasilAPI como fallback).
 *
 * Resposta sempre normalizada — mesmos campos independente da fonte.
 */
export const lookupCNPJ = async (cnpj) => {
  const c = String(cnpj || '').replace(/\D/g, '');
  if (c.length !== 14) return { ok: false, error: 'CNPJ inválido' };

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      return { ok: false, error: 'Sessão expirada — faça login novamente.' };
    }

    const r = await fetch(`/api/cnpj?q=${c}`, {
      headers: { Authorization: `Bearer ${session.access_token}` },
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || !j.ok) {
      return { ok: false, error: j.error || `Erro ${r.status} na consulta.` };
    }
    return { ok: true, data: j.data, source: j.source };
  } catch (err) {
    return { ok: false, error: err?.message || 'Erro ao consultar CNPJ' };
  }
};
